import { render, staticRenderFns } from "./NoteForm.vue?vue&type=template&id=52e42db5&scoped=true"
import script from "./NoteForm.vue?vue&type=script&lang=ts"
export * from "./NoteForm.vue?vue&type=script&lang=ts"
import style0 from "./NoteForm.vue?vue&type=style&index=0&id=52e42db5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e42db5",
  null
  
)

export default component.exports